import React from 'react';
import './blog-post.css';
//import reportWebVitals from './reportWebVitals';

const ElectionsResults = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>2023-24 Officer Election Results Announcement</h2>
                    <p class="site-post-meta">May 22, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Thank you to everybody who supported and ran in our 2022-2023 elections. We are excited to announce the new 
                    officer board for next year!
                    <br></br>
                    <br></br>
                    Chair: Shreya Sathyanarayanan
                    <br></br>
                    <br></br>
                    Vice Chair: Czarin Isabelle Dela Cruz
                    <br></br>
                    <br></br>
                    Student Relations: Riva Gore
                    <br></br>
                    <br></br>
                    Public Relations: Jeewon Jung
                    <br></br>
                    <br></br>
                    Outreach Committee Head: Dilini Nissanka
                    <br></br>
                    <br></br>
                    Social Events Committee Head: Hannah Lee
                    <br></br>
                    <br></br>
                    Secretary/Treasurer: Manasa Lingireddy
                    <br></br>
                    <br></br>
                    Social Media Director: Betty Cheng
                    <br></br>
                    <br></br>
                    Congratulations to the incoming officer board! We can't wait to see what you accomplish.
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    Best, 
                    <br></br>
                    <br></br>
                    WiC Officers 2022-23
                    </p>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default ElectionsResults;

